import React from 'react';
import AdminAuthProvider from './auth/AdminAuthProvider';
import { AdminUserProvider } from './auth/AdminUserContext';

/**
 * AdminAuthGuard - Protects admin routes with server-side authentication
 * 
 * This component wraps admin routes with proper authentication and user context
 * using secure server-side validation via Cloudflare Pages Functions
 */
const AdminAuthGuard = ({ children }) => {
  return (
    <AdminUserProvider>
      <AdminAuthProvider>
        {children}
      </AdminAuthProvider>
    </AdminUserProvider>
  );
};


export default AdminAuthGuard;